export default function scrollAnimationHeader() {
	const navbar = document.querySelector('.site-header');
	window.addEventListener('scroll', () => {
		if (window.scrollY > 200) {
			navbar.classList.add('navbar-scroll');
		} else{
			navbar.classList.remove('navbar-scroll');
		}
	});
}